import { Component, Input, OnDestroy, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { KompaktdarstellungTemplateComponent } from '../../../../shared/kompaktdarstellung/kompakt-darstellung-template.component';
import { BelegEntry } from '../../../../core/gb-api';
import { BelegAltReferenzObjektTyp, DokulinkItem } from '../../../../shared/components/dokulink/dokulinkItem';
import { FormatConfigService } from '../../../../core/services/format-config.service';
import { NgTemplateOutlet, PlatformLocation } from '@angular/common';
import { ComponentLocationStrategy } from '../../../../shared/services/location-strategy/component-location-strategy';
import { DokulinkItemBuilderFactory } from '../../../../shared/components/dokulink/dokulinkItemBuilderFactory';
import {
  BelegAltDokuLinkItemBuilder,
  BelegOhneGeschaeftDokuLinkItemBuilder
} from '../../../../shared/components/dokulink/dokulinkItemBuilder';
import { DatumPipe } from '../../../../shared/pipes/simple/datum.pipe';
import { DokulinkComponent } from '../../../../shared/components/dokulink/dokulink.component';
import { FormatBelegPipe } from '../../../../shared/pipes/format/format-beleg.pipe';
import { HistoryDirective } from '../../../../shared/directives/history.directive';

@Component({
  selector: 'cap-kompakt-beleg-icp',
  imports: [DatumPipe, DokulinkComponent, FormatBelegPipe, NgTemplateOutlet, HistoryDirective],
  templateUrl: './kompakt-beleg-icp.component.html'
})
export class KompaktBelegIcpComponent extends KompaktdarstellungTemplateComponent implements OnInit, OnDestroy {
  private _item: BelegEntry;
  @Input()
  set item(value: BelegEntry) {
    this._item = value;
    this.updateItemDependentState();
  }

  get item(): BelegEntry {
    return this._item;
  }

  @Input() histInfo;
  @Input() mitDatum = true;
  @Input() isEigentuemer = false;
  @Input() showBeleg = true;

  @Input() referenzObjectId: string;
  @Input() referenzObjectType: BelegAltReferenzObjektTyp;
  @ViewChild('typ00', { static: true }) typ00Template: TemplateRef<any>;
  @ViewChild('typ01', { static: true }) typ01Template: TemplateRef<any>;
  @ViewChild('typ02', { static: true }) typ02Template: TemplateRef<any>;
  @ViewChild('typ03', { static: true }) typ03Template: TemplateRef<any>;
  existingGeschaeft: boolean = false;
  isDokuLinkGeschaeftConfigured: boolean = false;
  isCmisGeschaeftConfigured = false;
  protected dokulinkItem: DokulinkItem;

  constructor(
    formatService: FormatConfigService,
    location: PlatformLocation,
    locationStrategy: ComponentLocationStrategy,
    private appformatConfigService: FormatConfigService,
    protected dokuLinkBuilderFactory: DokulinkItemBuilderFactory
  ) {
    super(formatService, 'BELEG', location, locationStrategy);
  }

  ngOnInit() {
    super.ngOnInit();
    this.addSub(
      this.appformatConfigService.settingsConfig$.subscribe((config) => {
        this.isDokuLinkGeschaeftConfigured = config?.isDokuLinkGeschaeftConfigured;
      })
    );
    this.updateItemDependentState();
  }

  private updateItemDependentState() {
    this.existingGeschaeft = this.item?.geschaeftId !== undefined;
    this.dokulinkItem = this.getDokulinkItem();
  }

  getDefaultTemplate(): TemplateRef<any> {
    return this.typ00Template;
  }

  registerTemplates() {
    this.bindTemplates(this.typ00Template, 'BELEG_TYP00');
    this.bindTemplates(this.typ01Template, 'BELEG_TYP01');
    this.bindTemplates(this.typ02Template, 'BELEG_TYP02');
    this.bindTemplates(this.typ03Template, 'BELEG_TYP03');
  }

  private getDokulinkItem(): DokulinkItem {
    if (this.item.alt) {
      return (<BelegAltDokuLinkItemBuilder>this.dokuLinkBuilderFactory.create('BELEG_ALT'))
        .setBelegAltEntry(this.item, this.referenzObjectId, this.referenzObjectType)
        .build();
    } else {
      if (this.item.geschaeftId) {
        return this.dokuLinkBuilderFactory.create('BELEG').setEntry(this.item).build();
      } else {
        return (<BelegOhneGeschaeftDokuLinkItemBuilder>this.dokuLinkBuilderFactory.create('BELEG_OHNE_GESCHAEFT'))
          .setBelegOhneGeschaeftEntry(this.item, this.referenzObjectId, this.referenzObjectType)
          .build();
      }
    }
  }
}
